// actions/metaActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getClasses = () => async (dispatch) => {
  try {
    dispatch({ type: "CLASSES_REQUEST" });
    const { data } = await api.get("/classes");
    dispatch({ type: "GET_CLASSES_SUCCESS", payload: data.classes });
  } catch (err) {
    dispatch({ type: "CLASSES_FAIL", payload: err.response?.data?.message });
  }
};

export const getSections = (params) => async (dispatch) => {
  try {
    dispatch({ type: "SECTIONS_REQUEST" });
    // Accept both: getSections(1) and getSections({ class_id: 1 })
    const queryParams =
      typeof params === "object" ? params : params ? { class_id: params } : {};
    const { data } = await api.get("/sections", { params: queryParams });
    dispatch({ type: "GET_SECTIONS_SUCCESS", payload: data.sections });
  } catch (err) {
    dispatch({ type: "SECTIONS_FAIL", payload: err.response?.data?.message });
  }
};

export const getSubjects = (classId) => async (dispatch) => {
  try {
    dispatch({ type: "SUBJECTS_REQUEST" });
    const params = classId ? { class_id: classId } : {};
    const { data } = await api.get("/subjects", { params });
    dispatch({ type: "GET_SUBJECTS_SUCCESS", payload: data.subjects });
  } catch (err) {
    dispatch({ type: "SUBJECTS_FAIL", payload: err.response?.data?.message });
  }
};

export const getAcademicYears = () => async (dispatch) => {
  try {
    const { data } = await api.get("/academic-years");
    dispatch({
      type: "GET_ACADEMIC_YEARS_SUCCESS",
      payload: data.academicYears,
    });
  } catch (err) {}
};
